"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamsFxUrlNames = exports.ErrorNames = exports.Retry = void 0;
const constants_1 = require("../../driver/teamsApp/constants");
/**
 * @author Qianhao Dong <qidon@microsoft.com>
 */
class Retry {
    static RETRY_TIMES = 6;
    static BACKOFF_TIME_MS = 5000;
}
exports.Retry = Retry;
class ErrorNames {
    // System Exceptions
    static PRECONDITION_ERROR = "PreconditionError";
    static PROVISION_ERROR = "ProvisionError";
    static CONFIG_UPDATING_ERROR = "ConfigUpdatingError";
    static CONFIG_VALIDATION_ERROR = "ConfigValidationError";
    static BOT_REGISTRATION_NOTFOUND_ERROR = "BotRegistrationNotFoundError";
    static MSG_ENDPOINT_UPDATING_ERROR = "MessageEndpointUpdatingError";
    static COMMAND_EXECUTION_ERROR = "CommandExecutionError";
    static CALL_APPSTUDIO_API_ERROR = "CallAppStudioAPIError";
    static CREATE_BOT_REGISTRATION_API_ERROR = "CreateBotRegistrationApiError";
    // User Exceptions
    static PACK_DIR_EXISTENCE_ERROR = "PackDirectoryExistenceError";
    static ACQUIRE_BOT_FRAMEWORK_TOKEN_ERROR = "AcquireBotFrameworkTokenError";
    static FORBIDDEN_RESULT_BOT_FRAMEWORK_ERROR = "ForbiddenResultBotFrameworkError";
    static CONFLICT_RESULT_BOT_FRAMEWORK_ERROR = "ConflictResultBotFrameworkError";
}
exports.ErrorNames = ErrorNames;
exports.TeamsFxUrlNames = {
    [constants_1.APP_STUDIO_API_NAMES.CREATE_BOT]: "<create-bot-registration>",
    [constants_1.APP_STUDIO_API_NAMES.GET_BOT]: "<get-bot-registration>",
    [constants_1.APP_STUDIO_API_NAMES.UPDATE_BOT]: "<update-message-endpoint>",
};
//# sourceMappingURL=constants.js.map